import React from "react";
import Context from "./context.js";
import axios from "axios";
import Cookies from "universal-cookie";
import host from "./host";

const cookies = new Cookies();

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  async submit() {
    try {
      this.setState({ loading: true });
      const ipResponse = await axios.get("https://api.bigdatacloud.net/data/client-ip");
      const ip = ipResponse.data.ipString;

      const name = document.getElementById("userName").value.trim();
      const password = document.getElementById("password").value.trim();

      const response = await axios.post(host + "users/auth/login", {
        phone: name,
        password: password,
        ip: ip,
      });

      cookies.set("token", response.data.data.token, {
        path: "/",
        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
      });
      
      window.location.href = "/";
    } catch (error) {
      
      window.alert(error.response.data.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const styles = {
      container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "linear-gradient(to right, #2c3e50, #3498db)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      },
      card: {
        backgroundColor: "#fff",
        padding: "40px 30px",
        borderRadius: "16px",
        boxShadow: "0 0 25px rgba(0, 0, 0, 0.1)",
        width: "100%",
        maxWidth: "400px",
      },
      title: {
        textAlign: "center",
        marginBottom: "25px",
        color: "#333",
        fontSize: "24px",
        fontWeight: "bold",
      },
      form: {
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      },
      input: {
        padding: "12px 16px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        fontSize: "16px",
        outline: "none",
        transition: "border-color 0.2s",
      },
      button: {
        backgroundColor: "#3498db",
        color: "white",
        padding: "12px",
        fontSize: "16px",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "background-color 0.2s",
      },
      buttonDisabled: {
        backgroundColor: "#7f8c8d",
        cursor: "not-allowed",
      },
    };

    return (
      <Context.Consumer>
        {(ctx) => (
          <div style={styles.container}>
            <div style={styles.card}>
              <h2 style={styles.title}>تسجيل الدخول</h2>
              <div style={styles.form}>
                <input
                  style={styles.input}
                  type="text"
                  id="userName"
                  placeholder="رقم الهاتف"
                />
                <input
                  style={styles.input}
                  type="password"
                  id="password"
                  placeholder="كلمة المرور"
                />
                <button
                  style={{
                    ...styles.button,
                    ...(this.state.loading ? styles.buttonDisabled : {}),
                  }}
                  onClick={() => this.submit()}
                  disabled={this.state.loading}
                >
                  {this.state.loading ? "جارٍ التحقق..." : "دخول"}
                </button>
              </div>
            </div>
          </div>
        )}
      </Context.Consumer>
    );
  }
}

export default Login;
